export { QueryService as CnidariumService } from '../../gen/penumbra/cnidarium/v1/cnidarium_connect.js';
